// Added by Sejune Oh on 2020-02-17
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

// Util
import { getCookie } from '@/helper/util'
import { ACCESS_TOKEN } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! study date 조건으로 reading study 목록을 구함
interface ReqGetLCSLungRADSCategoryProps {
  proxyToken: string
  study_date_from?: string | Date
  study_date_to?: string | Date
}
interface ResGetLCSLungRADSCategoryProps {
  items: {
    patient_id: string
    study_instance_uid: string
    study_date: Date
    reading_date: Date
    lungrads_category: string
  }[]
}
export const reqGetLCSLungRADSCategory = async ({ proxyToken, study_date_from, study_date_to }: ReqGetLCSLungRADSCategoryProps) => {
  let query = study_date_from ? `?study_date_from=${study_date_from}` : ''
  query += study_date_to ? (query ? '&' : '?') + `study_date_to=${study_date_to}` : ''

  return await axios.get<ResGetLCSLungRADSCategoryProps>(
    `v1/data/${proxyToken}/dcm/studies:lcs-lungrads-category${query}`
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! scocre별 study 개수를 구함
interface ReqGetLCSReadingStudyCountByScoreProps {
  proxyToken: string
}
interface ResGetLCSReadingStudyCountByScoreProps {
  items: {
    score: string
    count: string
  }[]
}
export const reqGetLCSReadingStudyCountByScore = async ({ proxyToken }: ReqGetLCSReadingStudyCountByScoreProps) => {
  return await axios.get<ResGetLCSReadingStudyCountByScoreProps>(
    `v1/data/${proxyToken}/dcm/studies:lcs-reading-study-count-by-score`
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! study 전체 수와 reading 수를 구함
interface ReqGetTotalAndLCSReadingStudyCount {
  proxyToken: string
}
interface ResGetTotalAndLCSReadingStudyCount {
  study_count: string
  reading_count: string
}
export const reqGetTotalAndLCSReadingStudyCount = async ({ proxyToken }: ReqGetTotalAndLCSReadingStudyCount) => {
  return await axios.get<ResGetTotalAndLCSReadingStudyCount>(
    `v1/data/${proxyToken}/dcm/studies:total-and-lcs-reading-study-count`
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! study date 조건으로 reading study 목록을 계산하여 CSV 파일로 생성함.
interface ReqExportLCSReultProps {
  proxy_token: string
  study_date_from ?: string
  study_date_to ?: string
}
export const reqExportLCSResult = async (props: ReqExportLCSReultProps, filename: string) => {
  const accessToken = getCookie(ACCESS_TOKEN)
  const { data : { path }} = await axios.post(`v1/data/${props.proxy_token}/dcm/studies:export-lcs-result`, { ...props })
  return `${axios.defaults.baseURL}/v1/data/${props.proxy_token}/task-result/${path}?access-token=${accessToken}&mode=download&filename=${filename}`
}
